import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateCalculateReferralPrice = {
  calculateReferralPrice: { data: null, loading: false, error: null },
};

export const calculateReferralPrice = createAsyncThunk(
  'referral/calculateReferralPrice',
  async (price, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage?.getItem('token');
    if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
    
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_API}/referrals/calculate-price/`,
        { price },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Unknown error' });
    }
  }
);

export const reducerCalculateReferralPrice = {
  [calculateReferralPrice.pending]: (state) => {
    state.calculateReferralPrice.loading = true;
  },
  [calculateReferralPrice.fulfilled]: (state, action) => {
    state.calculateReferralPrice.loading = false;
    state.calculateReferralPrice.data = action.payload;
    state.calculateReferralPrice.error = null;
  },
  [calculateReferralPrice.rejected]: (state, action) => {
    state.calculateReferralPrice.loading = false;
    state.calculateReferralPrice.data = action?.payload;
    state.calculateReferralPrice.error = true;
  },
}; 